<template>
  <main class="container-1">

    <div class="container-header">
      <Breadcrumb :links="routesBread" />
      <!-- <h2>Mapas</h2> -->
      <TabNav :links="routesNav" />
    </div>

    <div class="container-body">

      <!-- Tarjetas resumen -->
      <div class="summary-cards">
        <div class="summary-card">
          <span class="summary-card__value">{{ monitoringSummary ? monitoringSummary.map_visits_today : '–' }}</span>
          <span class="summary-card__label">Visitas a mapas hoy</span>
        </div>
        <div class="summary-card">
          <span class="summary-card__value">{{ monitoringSummary ? monitoringSummary.sessions_today : '–' }}</span>
          <span class="summary-card__label">Sesiones de capas hoy</span>
        </div>
        <div class="summary-card">
          <span class="summary-card__value">{{ monitoringSummary ? monitoringSummary.active_users : '–' }}</span>
          <span class="summary-card__label">Usuarios activos</span>
        </div>
      </div>

      <hr class="section-divider" />

      <!-- Gráfico: accesos a mapas (línea temporal por hora) -->
      <section class="chart-section">
        <div class="chart-section__header">
          <h3>Accesos a mapas</h3>
        </div>
        <div class="chart-filters">
          <label class="monitoring-filter-label">Desde</label>
          <input v-model="c3DateFrom" type="date" class="monitoring-filter-date" @change="loadChart3" />
          <label class="monitoring-filter-label">Hasta</label>
          <input v-model="c3DateTo" type="date" class="monitoring-filter-date" @change="loadChart3" />
        </div>
        <apexchart type="line" height="260" :options="c3Options" :series="c3Series" />
        <p class="chart-note">Cada punto = una hora del día · registros disponibles los últimos {{ ttlMapDays }} días · hora local Chile.</p>
      </section>

      <!-- Estadísticas de uso por mapa -->
      <section class="monitoring-section">
        <div class="monitoring-section__header">
          <h3>Uso por mapa</h3>
        </div>
        <p class="monitoring-hint">Basado en sesiones de capas y visitas directas al mapa.</p>

        <div class="monitoring-filters monitoring-filters--dates">
          <label class="monitoring-filter-label">Desde</label>
          <input v-model="dateFromMaps" type="date" class="monitoring-filter-date" @change="applyMapsFilter" />
          <label class="monitoring-filter-label">Hasta</label>
          <input v-model="dateToMaps" type="date" class="monitoring-filter-date" @change="applyMapsFilter" />
          <button v-if="dateFromMaps || dateToMaps" class="monitoring-filter-clear" @click="clearMapsDateFilter">✕</button>
        </div>
        <div class="monitoring-filters">
          <input v-model="filterMaps" class="monitoring-filter-input" type="text" placeholder="Buscar por mapa o usuario…" />
          <button v-if="filterMaps" class="monitoring-filter-clear" @click="filterMaps = ''">✕</button>
          <button v-if="hasActiveMapsFilters" type="button" class="filters-clear-btn" @click="clearMapsFilters">Limpiar filtros</button>
        </div>

        <table v-if="mapHistory.length > 0" class="monitoring-table">
          <thead>
            <tr>
              <th class="sortable" @click="onSortMaps('map_name')">
                Mapa <font-awesome-icon :icon="getSortIconMaps('map_name')" />
              </th>
              <th class="sortable" @click="onSortMaps('user')">
                Usuario <font-awesome-icon :icon="getSortIconMaps('user')" />
              </th>
              <th class="sortable" @click="onSortMaps('sessions')">
                Acciones de capas <font-awesome-icon :icon="getSortIconMaps('sessions')" />
              </th>
              <th class="sortable" @click="onSortMaps('visits')">
                Visitas al mapa <font-awesome-icon :icon="getSortIconMaps('visits')" />
              </th>
              <th class="sortable" @click="onSortMaps('last_activity')">
                Última actividad <font-awesome-icon :icon="getSortIconMaps('last_activity')" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in mapHistory" :key="i">
              <td>{{ item.map_name || item.map_id || 'Entrada Vacía' }}</td>
              <td>{{ [item.firstname, item.lastname].filter(Boolean).join(' ') || 'Entrada Vacía' }}</td>
              <td>{{ item.total_sessions }}</td>
              <td>{{ item.map_visits || 0 }}</td>
              <td>{{ item.last_activity ? formatDate(item.last_activity) : 'Entrada Vacía' }}</td>
            </tr>
          </tbody>
        </table>
        <p v-else class="monitoring-empty">{{ filterMaps ? 'Sin resultados para el filtro aplicado.' : 'No hay datos de uso de mapas todavía.' }}</p>
        <div v-show="totalPagesMapHistory > 1" class="pagination-wrap">
          <Pagination
            :totalPages="totalPagesMapHistory"
            :currentPage="currentPageMaps"
            :pageSize="15"
            @pagechanged="mapsPageChanged"
          />
        </div>
      </section>

    </div>

    <!-- <SideNav class="container-sidenav" :links="routesNav" /> -->

  </main>
</template>

<script>
var moment = require('moment')

import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Pagination from '@/components/Pagination.vue'
import TabNav from '@/components/TabNav.vue'
import { restMonitoring } from '@/components/mixin/restMonitoring.js'

export default {
  components: { SideNav, Breadcrumb, Pagination, TabNav },
  mixins: [restMonitoring],
  data() {
    return {
      filterMaps: '',
      currentPageMaps: 1,
      dateFromMaps: '',
      dateToMaps: '',
      sortKeyMaps: '',
      sortOrderMaps: 'asc',
      c3DateFrom: '',
      c3DateTo: '',
      c3Data: [],
      ttlMapDays: 180
    }
  },
  computed: {
    c3Options() {
      return {
        chart: { type: 'line', toolbar: { show: false }, fontFamily: 'inherit', animations: { enabled: false }, zoom: { enabled: false } },
        stroke: { curve: 'straight', width: 2 },
        markers: { size: 3, hover: { size: 5 } },
        xaxis: {
          categories: this.c3Data.map(d => d.date),
          tickAmount: 10,
          labels: { rotate: -30, style: { fontSize: '11px' } }
        },
        yaxis: { title: { text: 'Accesos' }, min: 0, forceNiceScale: true },
        colors: ['#3b6e94'],
        dataLabels: { enabled: false },
        tooltip: { theme: 'light' },
        noData: { text: 'Sin datos para el período seleccionado', style: { color: '#aaa', fontSize: '13px' } }
      }
    },
    c3Series() {
      return [{ name: 'Accesos', data: this.c3Data.map(d => d.count) }]
    },
    hasActiveMapsFilters() {
      return this.filterMaps !== '' ||
        this.dateFromMaps !== '' ||
        this.dateToMaps !== '' ||
        this.sortKeyMaps !== ''
    },
    routesNav() {
      return [
        { name: 'Secciones' },
        { name: 'General', path: '/monitoreo/general' },
        { name: 'Mapas', path: '/monitoreo/mapas' },
        { name: 'Capas', path: '/monitoreo/capas' },
        { name: 'Terreno', path: '/monitoreo/terreno' },
      ]
    },
    routesBread() {
      return [{ name: 'Monitoreo' }]
    }
  },
  watch: {
    filterMaps(val) {
      clearTimeout(this._mapsSearchTimer)
      this._mapsSearchTimer = setTimeout(() => {
        this.currentPageMaps = 1
        this.getMapHistory(1, this.dateFromMaps, this.dateToMaps, val, this.sortKeyMaps, this.sortOrderMaps)
      }, 400)
    }
  },
  methods: {
    today() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` },
    daysAgo(n) { const d = new Date(); d.setDate(d.getDate() - n); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` },
    loadChart3() {
      this.getChartMapVisitsByHour(this.c3DateFrom, this.c3DateTo, '')
        .then(data => { this.c3Data = data })
    },
    formatDate(date) {
      moment.locale('es')
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    refreshMaps() {
      this.getMapHistory(this.currentPageMaps, this.dateFromMaps, this.dateToMaps, this.filterMaps, this.sortKeyMaps, this.sortOrderMaps)
      this.getSummary()
      this.loadChart3()
    },
    applyMapsFilter() {
      this.currentPageMaps = 1
      this.getMapHistory(1, this.dateFromMaps, this.dateToMaps, this.filterMaps, this.sortKeyMaps, this.sortOrderMaps)
    },
    clearMapsDateFilter() {
      this.dateFromMaps = ''
      this.dateToMaps = ''
      this.applyMapsFilter()
    },
    clearMapsFilters() {
      this.filterMaps = ''
      this.dateFromMaps = ''
      this.dateToMaps = ''
      this.sortKeyMaps = ''
      this.sortOrderMaps = 'asc'
      this.applyMapsFilter()
      // El watcher de filterMaps agenda un fetch debounced redundante; se cancela
      this.$nextTick(() => clearTimeout(this._mapsSearchTimer))
    },
    mapsPageChanged(page) {
      this.currentPageMaps = page
      this.getMapHistory(page, this.dateFromMaps, this.dateToMaps, this.filterMaps, this.sortKeyMaps, this.sortOrderMaps)
    },
    onSortMaps(key) {
      if (this.sortKeyMaps === key) {
        if (this.sortOrderMaps === 'asc') {
          this.sortOrderMaps = 'desc'
        } else {
          this.sortKeyMaps = ''
          this.sortOrderMaps = 'asc'
        }
      } else {
        this.sortKeyMaps = key
        this.sortOrderMaps = 'asc'
      }
      this.currentPageMaps = 1
      this.getMapHistory(1, this.dateFromMaps, this.dateToMaps, this.filterMaps, this.sortKeyMaps, this.sortOrderMaps)
    },
    getSortIconMaps(key) {
      if (this.sortKeyMaps !== key) return 'sort'
      return this.sortOrderMaps === 'asc' ? 'sort-up' : 'sort-down'
    }
  },
  created() {
    if (!this.$store.getters.getPermissions || !this.$store.getters.getPermissions.monitoring) {
      this.$router.push('/pagina-no-encontrada')
    }
  },
  mounted() {
    this.dateFromMaps = this.daysAgo(60)
    this.dateToMaps = this.today()
    this.c3DateFrom = this.daysAgo(60)
    this.c3DateTo = this.today()
    this.refreshMaps()
    this.loadChart3()
  },
  beforeDestroy() {
    clearTimeout(this._mapsSearchTimer)
  }
}
</script>

<style lang="scss" scoped>
.summary-cards {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.summary-card {
  flex: 1;
  min-width: 110px;
  padding: 0.85rem 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;

  &__value {
    display: block;
    font-size: 1.9em;
    font-weight: 700;
    color: var(--color-steel);
    line-height: 1;
  }

  &__label {
    display: block;
    font-size: 0.78em;
    color: #777;
    margin-top: 0.35rem;
  }
}

.monitoring-section {
  margin-bottom: 1rem;

  &__header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.5rem;

    h3 {
      margin: 0;
    }
  }
}

.monitoring-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;

  &--dates {
    flex-wrap: nowrap;
  }
}

.monitoring-filter-input {
  flex: 1;
  padding: 0.4rem 0.65rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85em;
  outline: none;

  &:focus {
    border-color: var(--color-steel);
  }
}

.monitoring-filter-label {
  font-size: 0.82em;
  color: #666;
  white-space: nowrap;
}

.monitoring-filter-date {
  padding: 0.3rem 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85em;
  outline: none;

  &:focus {
    border-color: var(--color-steel);
  }
}

.monitoring-filter-clear {
  background: transparent;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #888;
  cursor: pointer;
  font-size: 0.8em;
  padding: 0.25rem 0.5rem;

  &:hover {
    color: #c0392b;
    border-color: #c0392b;
  }
}

.refresh-btn {
  background: transparent;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  padding: 0.28rem 0.65rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #555;
  font-size: 0.85em;
  line-height: 1;
  white-space: nowrap;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  &:hover {
    border-color: var(--color-steel);
    color: var(--color-steel);
  }
}

.monitoring-hint {
  color: #888;
  font-size: 0.85em;
  margin-bottom: 0.75rem;
}

.chart-section {
  margin-bottom: 1rem;
  background: #f9fafb;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 1rem 1.25rem 0.75rem;

  &__header h3 {
    margin: 0 0 0.75rem;
    font-size: 1em;
    color: #333;
  }
}

.chart-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
  margin-bottom: 0.75rem;
}

.chart-note {
  margin: 0.5rem 0 0;
  font-size: 0.78em;
  color: #f59e0b;
  font-style: italic;
}

.monitoring-empty {
  color: #888;
  font-style: italic;
}

.pagination-wrap {
  margin-top: 1rem;
}

.monitoring-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9em;

  th, td {
    padding: 0.5rem 0.75rem;
    text-align: left;
    border-bottom: 1px solid #e5e5e5;
  }

  th {
    background: var(--color-navy);
    color: #fff;
    font-weight: 600;
  }

  th.sortable {
    cursor: pointer;
    user-select: none;
  }

  th.sortable:hover {
    background: var(--color-steel);
  }

  tr:hover td {
    background: #fafafa;
  }
}

.section-divider {
  border: none;
  border-top: 1px solid var(--color-line);
  margin: 0 0 1rem;
}

</style>
